import React, { Component } from 'react';
import Tabletop from 'tabletop';

class Endurance extends Component {
	constructor() {
		super()
		this.state = {
			data: []
		}
	}

	componentDidMount() {
		Tabletop.init({
			key: '1mjOFBzgVW_KRZY0hBoB87uCWIrbfbaepC-RUCR-9Lnc',
			callback: googleData => {
				this.setState({
					data: googleData
				})
			},
			simpleSheet: true
		})
	}

	render() {
		const { data } = this.state
		return (
			<div className="Overall">
				<div className="flex content-center">
					<div className="flex-grow self-center px-4">
						<h2 className="endurance">Endurance Championship</h2>
						<p><small>Ordered by dropped score</small></p>
					</div>
				</div>

				<div className="flex">
					<div className="col full px-4">
						<div className="overallTable table-responsive endurance">
							<table cellPadding="0" cellSpacing="0" border="0" className="table">
								<thead>
									<tr>
										<th>Pos</th>
										<th>Driver</th>
										<th className="overall">Overall</th>
										<th className="ds">DS</th>
									</tr>
								</thead>
								<tbody>
								{
									data.map(obj => {
										return (
											<tr key={obj.driver}>
												<td>{obj.pos}</td>
												<td className="grow"><img src={obj.endCar} alt={obj.driver} width="60" /> {obj.driver}</td>
												<td><span>{obj.endurance}</span></td>
												<td><span>{obj.enduranceDs}</span></td>
											</tr>
										)
									})
								}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Endurance;
